var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayStore = function SvgPlayStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "-1.2 -1.2 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.321 1.359A1.854 1.854 0 0 0 .675 3.042v15.516a1.854 1.854 0 0 0 2.646 1.683l16.533-7.758a1.854 1.854 0 0 0 0-3.366zm.567.261 13.167 12.177m-12.96 6.084L16.992 7.776"
  })));
};
export default SvgPlayStore;